<template>
  <div class="block" v-show="orderDetail">
    <div v-show="!checkView">
      <form method="post" ref="form" :action="cybersource.URL">
        <h2>
         {{$t('mall_pay_order.payment_method')}} <!-- 請選擇您期望的支付方式 -->
        </h2>
        <div class="payType">
          <div class="pointer" style="margin-right: 15px" @click="cybersource.card_type = '001'">
            <img :src="require('@/assets/img/order/pay_visa.png')">
            <div>
              <img v-if="cybersource.card_type === '001'" :src="require('@/assets/img/order/ico_selected.png')">
              <img v-else :src="require('@/assets/img/order/ico_select.png')">
              <span>Visa</span>
            </div>
          </div>
          <div class="pointer" @click="cybersource.card_type = '002'">
            <img :src="require('@/assets/img/order/pay_master.png')">
            <div>
              <img v-if="cybersource.card_type === '002'" :src="require('@/assets/img/order/ico_selected.png')">
              <img v-else :src="require('@/assets/img/order/ico_select.png')">
              <span>Master</span>
            </div>
          </div>
        </div>
        <div class="row">
          <span class="cell left">
           {{$t('mall_confirm_order.surname')}}<!-- 姓氏 -->
          </span>
          <input class="forename cell right" v-model="cybersource.bill_to_forename"
                 :placeholder="oldData.bill_to_forename ? oldData.bill_to_forename : $t('mall_confirm_order.input_surname')">
        </div>
        <div class="row">
          <span class="cell left">
            {{$t('mall_confirm_order.given_name')}}<!-- 名字 -->
          </span>
          <input class="surname cell right" v-model="cybersource.bill_to_surname"
                 :placeholder="oldData.bill_to_surname ? oldData.bill_to_surname : $t('mall_confirm_order.input_name')">
        </div>
        <div class="row">
          <span class="cell left">
            {{$t('mall_confirm_order.email')}}<!-- 郵箱 -->
          </span>
          <input class="email cell right" v-model="cybersource.bill_to_email"
                 :placeholder="oldData.bill_to_email ? oldData.bill_to_email : $t('mall_confirm_order.input_email')">
        </div>
        <div class="row">
          <span class="cell left">
            {{$t('mall_confirm_order.phone')}}<!-- 電話 -->
          </span>
          <input class="phone cell right" v-model="cybersource.bill_to_phone"
                 :placeholder="oldData.bill_to_phone ? oldData.bill_to_phone : $t('mall_confirm_order.input_phone')">
        </div>
        <div class="row">
          <span class="cell left">
            {{$t('mall_pay_order.credit_card')}}<!-- 信用卡號 -->
          </span>
          <input class="card_number cell right" maxlength="19"  v-model="cybersource.card_number" :placeholder="$t('mall_pay_order.input_credit_card')"
                 @keyup="cardNumberLimit">
        </div>
        <div class="row">
          <span class="cell left">
            {{$t('mall_pay_order.valid_term')}} <!-- 有效期 -->
          </span>
          <input class="cell mm" maxlength="2" v-model="expiry_mouth" placeholder="mm">
          <span class="cell">/</span>
          <input class="cell yy" maxlength="2" v-model="expiry_year" placeholder="yy" @keydown.delete="focusToMM($event)">
          <span class="cell right" style="cursor: text" @click="yyFocus"></span>
        </div>
        <div class="row">
          <span class="cell left">CVN</span>
          <input maxlength="3" class="card_cvn cell right" v-model="cybersource.card_cvn" :placeholder="$t('mall_pay_order.input_cvs')"
                 @keyup="cybersource.card_cvn = cybersource.card_cvn.replace(/\D/g,'')"  @keyup.enter="toCheck">
        </div>
      </form>
      <div style="text-align: right"><button class="pointer toCheck" @click="toCheck">
        {{$t('mall_order.pay')}}<!-- 確認支付 -->
      </button></div>
    </div>
    <div v-show="checkView">
      <div class="check">
        <h2>Payment Detail</h2>
        <span>
          <span class="left">Card Type</span>
          <span style="width: 10px"></span>
          <span class="right">{{ this.cybersource.card_type === '001' ? 'Visa' : 'Master '}}</span>
          </span>
        <span>
          <span class="left">Card Number</span>
          <span style="width: 10px"></span>
          <span class="right">{{ this.cybersource.card_number }}</span>
        </span>
        <span>
          <span class="left">Expiration Data</span>
          <span style="width: 10px"></span>
          <span class="right">{{ this.cybersource.card_expiry_date }}</span>
        </span>
      </div>
      <div class="check">
        <h2>Your Order</h2>
        <span>
          <span class="left">Total Amount</span>
          <span style="width: 10px"></span>
          <span class="right">HKD {{ this.cybersource.amount | PriceFormat }}</span>
        </span>
      </div>
      <div class="check" style="margin-top: 30px">
        <span>
          <el-button type="info" class="button" @click="checkView = false">Back</el-button>
          <span style="width: 10px"></span>
          <el-button type="warning" class="button" @click="toPay" v-loading.fullscreen.lock="loading">Pay</el-button>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
  import PriceFormat from '@/assets/js/PriceFormat';
  import Validator from '@/assets/js/Validator';
  export default {
    name: "PayOrder",
    data() {
      return {
        loading: false,
        orderId: '',
        orderDetail: null,
        oldData: {
          bill_to_forename: '',
          bill_to_surname: '',
          bill_to_email: '',
          bill_to_phone: '',
        },
        cybersource: {
          URL: 'https://testsecureacceptance.cybersource.com/silent/pay',
          card_type: '001',
          bill_to_forename: '',
          bill_to_surname: '',
          bill_to_email: '',
          bill_to_phone: '',
          card_number: '',
          card_expiry_date: '',
          card_cvn: '',
          amount: 0,
        },
        expiry_mouth: '',
        expiry_year: '',
        areaCodeList: [
          { value: '852', label: '+852' },
          { value: '86', label: '+86' }
        ],
        checkView: false,
      }
    },
    watch: {
      expiry_mouth: function () {
        this.expiry_mouth = this.expiry_mouth.replace(/\D/g,'');
        if (this.expiry_mouth > 12) {
          this.expiry_mouth = 12;
          $('.yy').focus();
        }
        if (this.expiry_mouth.length >= 2) {
          $('.yy').focus();
        }
        this.cybersource.card_expiry_date = this.expiry_mouth + '-20' + this.expiry_year;
      },
      expiry_year: function () {
        this.expiry_year = this.expiry_year.replace(/\D/g,'');
        if (this.expiry_year.length >= 2) {
          $('.card_cvn').focus();
        }
        this.cybersource.card_expiry_date = this.expiry_mouth + '-20' + this.expiry_year;
      }
    },
    filters: {
      PriceFormat (val) {
        return PriceFormat(val);
      }
    },
    methods: {
      focusToMM(el) {
        if (!el.target.value) {
          $('.mm').focus();
        }
      },
      cardNumberLimit() {
        let val = this.cybersource.card_number.replace(/\D/g,'');
        let len = val.length;
        if (len >= 16) {
          val = val.substring(0,16);
          $('.mm').focus()
        }
        this.cybersource.card_number = val.replace(/(.{4})/g, '$1 ').replace(/(^\s*)|(\s*$)/g, '');
      },
      yyFocus() {
        $('.yy').focus()
      },
      BillValidator() {
        if (!this.cybersource.bill_to_forename) {
          this.$notify.error({
            message: this.$t('mall_confirm_order.input_surname')//'請填寫姓氏'
          });
          $('.forename').focus();
          return false;
        }
        if (!this.cybersource.bill_to_surname) {
          $('.surname').focus();
          this.$notify.error({
            message: this.$t('mall_confirm_order.input_name')//'請填寫名字'
          });
          return false;
        }
        if (!Validator('email',{ email: this.cybersource.bill_to_email })) {
          return false;
        }
        if (!this.cybersource.bill_to_phone) {
          $('.phone').focus();
          this.$notify.error({
            message: this.$t('mall_pay_order.input_phone_num')//'請填寫電話'
          });
          return false;
        }
        if (!this.cybersource.card_number) {
          $('.card_number').focus();
          this.$notify.error({
            message: this.$t('mall_pay_order.input_credit_card')//'請填寫信用卡號'
          });
          return false;
        }
        if (this.expiry_mouth > 12|| this.expiry_mouth <= 0) {
          $('.mm').focus();
          this.$notify.error({
            message: this.$t('mall_pay_order.error_month')//'信用卡過期月份錯誤'
          });
          return false;
        }
        if (this.expiry_year.length !== 2) {
          $('.yy').focus();
          this.$notify.error({
            message: this.$t('mall_pay_order.error_year')//'信用卡過期年份錯誤'
          });
          return false;
        }
        if (this.cybersource.card_cvn.length !== 3) {
          $('.card_cvn').focus();
          this.$notify.error({
            message: this.$t('mall_pay_order.error_cvn')//'請輸入正確的CVN號碼'
          });
          return false;
        }
        return true;
      },
      toCheck() {
        if (this.BillValidator()) {
          this.$notify.info({
            message:this.$t('mall_pay_order.confirm_infor')// '請確認支付信息'
          })
          this.checkView = true;
          setTimeout(function () { window.scrollTo(0,120) })
        }
      },
      toPay() {
        this.$axios.post('mall_api/trans/purchase_direct_payment', {//獲取新的支付許可
          order_purchase_id : this.orderId,
          payments : {
            wallet: 0,
            carat: 0,
            direct_payment_union: "0",
            direct_payment_wechat: "0",
            direct_payment_alipay: "0",
            direct_payment_cybersource: {
              forename: this.cybersource.bill_to_forename,
              surname: this.cybersource.bill_to_surname,
              email: this.cybersource.bill_to_email,
              phone: this.cybersource.bill_to_phone,
              line1:"12312312312",
              city:"深圳",
              state:"hongkong",
              country:"TH",
              postal_code:"10120",
              amount: this.cybersource.amount
            }
          }
        }).then(res => {
          this.cybersource = Object.assign(this.cybersource, res.data.data.transaction_order.params);
          this.loading = true;
          for(let key in this.cybersource){
            var row = document.createElement("input");
            row.setAttribute('name', key);
            if (key === 'card_number') {
              row.setAttribute('value', this.cybersource[key].replace(/\D/g,''));
            } else {
              row.setAttribute('value', this.cybersource[key]);
            }
            row.style.visibility = 'hidden';
            row.style.position = 'absolute';
            this.$refs.form.appendChild(row);
          }
          this.$refs.form.submit();
        });
      },

      getOrderDetail() {
        this.$axios.get('api/app_v1/product/trans/pending_orders_v2').then(res => {
          this.orderDetail = res.data.data;
          if (!this.orderDetail) {
            this.$alert(this.$t('mall_confirm_order.no_more'),
              this.$t('mall_confirm_order.tips'), {
              confirmButtonText: this.$t('mall_confirm_order.sure'),
            }).then(() => {
              this.$router.push({ path: '/search/list?type=reco' });
            });
          }
          this.orderId = this.orderDetail.id;
          //舊的支付許可信息
          this.oldData = this.orderDetail.cybersource_string;
          this.cybersource = Object.assign(this.cybersource, this.orderDetail.cybersource_string);
        });
      }
    },
    mounted() {
    },
    created() {
      // this.cybersource.card_expiry_date = '10-2020';
      // this.cybersource.card_number = '4242 4242 4242 4242';
      // this.cybersource.card_cvn = '123';
      // this.expiry_year = '20';
      // this.expiry_mouth = '10';
      if (this.$route.path === '/order/fail') {
        this.$notify.error({
          message: this.$t('mall_pay_order.pay_fail')//'支付失敗，請檢查支付信息是否正確'
        });
        let url = process.env.DOMAIN + 'order/pay';
        history.replaceState(null, '', url);
      }
      this.$parent.changeTab(2);
      this.getOrderDetail();
    },
  }
</script>

<style scoped>
  select {
    background: none;
    border: none;
    border-right: 1px solid #DEDEDE;
  }
  h2 {
    font-size: 20px !important;
    color: #1E1303;
    font-weight:500;
    margin-bottom: 15px;
  }

  .block {
    font-size: 20px;
    padding-bottom: 50px;
  }
  .payType {
    display: flex;
    padding-bottom: 20px;
  }
  .payType>div {
    width: 178px;
  }
  .payType>div>img {
    display: block;
  }
  .payType>div>div {
    text-align: center;
  }

  .row {
    padding: 11px 0;
    display: flex;
    box-sizing: border-box;
    border:1px solid #DEDEDE;
    margin-bottom: 15px;
  }
  .row:focus {
    border:1px solid #BF4444;
  }
  .row .cell {
    font-size: 18px;
    padding-left: 10px;
  }
  .row .mm {
    width: 48px
  }
  .row .yy {
    width: 54px;
    text-align: center;
  }
  .row .left {
    box-sizing: border-box;
    width: 138px;
  }
  .row .right {
    flex: 1;
  }
  .toCheck {
    margin-top: 45px;
    font-size:16px;
    color: white;
    width:120px;
    height:44px;
    background: #1E1303;
  }
  .check {
    font-size: 18px;
  }
  .check>h2 {
    border-bottom: 1px solid #DDDDDD;
    padding: 20px 0 20px 0;
  }
  .check>span {
    display: flex;
    padding: 20px 0 20px 0;
  }
  .check>span .left {
    flex: 1;
  }
  .check>span .right {
    flex: 1;
  }
  .check .button {
    font-size: 20px;
    flex: 1;
  }
</style>



// WEBPACK FOOTER //
// src/views/viewHK/Order/PayOrder.vue